import ButtonSelector from '../../../buttonSelector/ButtonSelector'
import { FormFieldSelectProps } from '../_props'

const FormFieldSelect = <T extends object, O>({
    value,
    onChange,
    dataCy,
    dataCyScope,
    name,
    renderLabel,
    ...props
}: FormFieldSelectProps<T, O>) => (
    <ButtonSelector
        {...props}
        value={value}
        label={renderLabel && value ? renderLabel() : value ?? ''}
        dataCy={dataCy ?? `dataCy_${dataCyScope ?? 'FormFieldInput'}-${name.toString()}`}
        onChange={(e: any) => {
            onChange(e)
        }}
    />
)

export default FormFieldSelect
